import React, { useCallback, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import HmrcSubmission from './govuk/HmrcSubmission';
import subsidiaryClaimService from '@rd-web-markets/shared/dist/services/claim/subsidiary_claim.service';
import DropdownFormField from '@rd-web-markets/shared/dist/util/form/DropdownFormField';
const ClaimSelect = _ref => {
  let {
    company,
    claimList
  } = _ref;
  const [selectedClaim, setSelectedClaim] = useState(null);
  const [selectedSubsidiaryClaim, setSelectedSubsidiaryClaim] = useState(null);
  const selectClaim = event => {
    const targetClaim = claimList.find(c => c.id === Number(event.target.value));
    setSelectedClaim(targetClaim);
  };
  const {
    subsidiaryClaims,
    updateSubsidiaryClaimState,
    updateSubsidiaryClaim
  } = subsidiaryClaimService.useCrud({
    claimId: selectedClaim === null || selectedClaim === void 0 ? void 0 : selectedClaim.id
  });
  const selectSubsidiary = useCallback(subsidiaryId => {
    setSelectedSubsidiaryClaim(subsidiaryClaims.find(sc => sc.id === parseInt(subsidiaryId)));
  }, [subsidiaryClaims]);
  const doesNotRequireSubsidiary = !company.requires_separate_aif_submission;
  const requiresSubsidiaryAndItIsSelected = company.requires_separate_aif_submission && selectedSubsidiaryClaim;
  const canShowHmrcSubmission = selectedClaim && (doesNotRequireSubsidiary || requiresSubsidiaryAndItIsSelected);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("h2", null, "Gov.uk Claim application"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "roles",
    onChange: selectClaim
  }, /*#__PURE__*/React.createElement("option", {
    value: null
  }), claimList.map(claim => {
    return /*#__PURE__*/React.createElement("option", {
      key: claim.id,
      value: claim.id
    }, claim.name);
  })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "mt-3"
  }, selectedClaim ? /*#__PURE__*/React.createElement("h3", null, selectedClaim.name) : /*#__PURE__*/React.createElement("p", null, "please select a claim")), /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, selectedClaim && company.requires_separate_aif_submission && subsidiaryClaims.length && /*#__PURE__*/React.createElement(DropdownFormField, {
    label: "Select Subsidiary",
    values: subsidiaryClaims,
    valueAttributeName: 'id',
    textAttributeName: 'subsidiary_company.name',
    onChange: selectSubsidiary
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, canShowHmrcSubmission && /*#__PURE__*/React.createElement(HmrcSubmission, {
    company: company,
    claim: selectedClaim,
    subsidiaryClaim: selectedSubsidiaryClaim
  }))));
};
export default ClaimSelect;